import React from 'react'
import Icon, { IconType } from '@bt-react/components/Icon'
import Modal from '@bt-react/components/Modal'
import styles from './NetworkErrorModal.module.scss'

const NetworkErrorModal = () => <Modal
  concise={true}
  isOpen={true}
  hideBorder={true}
>
  <Modal.Header
    className={styles[`Header`]}
    dataBdd='dialog-network-error-header'
    hideBorder={true}
  >
    <div className={styles[`Header--centered`]}>
      <Icon
        className={styles['icon']}
        colour={IconType.colour.task}
        name={IconType.iconName.danger}
      />&nbsp;
      <span data-bdd='dialog-network-error-message' className={styles['heading-text-400']} >Connectivity Issues</span>
    </div>
  </Modal.Header>
  <Modal.Body className={styles[`Body`]} dataBdd={`dialog-network-error-body`}>
    <p>You are experiencing connection difficulties.</p>
    <p>Please wait while we try to reconnect you.  Alternatively try refreshing this page.</p>
  </Modal.Body>
  <Modal.Footer className={styles[`Footer`]}></Modal.Footer>
</Modal>

export default NetworkErrorModal
